export default __webpack_public_path__ + "static/media/check.3e93773e.svg";